// Arabisch (ar), email: zelfde vorm als email.nl.ts. Productnaam en adressen blijven in Latijns
// schrift ({product}, {origin}, {host}); lijsten (lines) hebben dezelfde lengte als in nl.
export const emailAr = {
    buttonFallback: 'الزر لا يعمل؟ انسخ هذا الرابط: {url}',
    verify: {
        subject: 'أكّد بريدك الإلكتروني لـ {product}',
        lines: [
            'أهلًا بك! أكّد بريدك الإلكتروني لتتمكن من استخدام لوحة عائلتك.',
            'هذا الرابط صالح لمدة 24 ساعة. لم تنشئ حسابًا؟ تجاهل هذه الرسالة إذن.',
        ],
        cta: 'تأكيد البريد الإلكتروني',
    },
    reset: {
        subject: 'إعادة تعيين كلمة المرور',
        lines: [
            'طلبت كلمة مرور جديدة.',
            'هذا الرابط صالح لمدة 60 دقيقة ويعمل مرة واحدة. لم تطلب ذلك؟ تجاهل هذه الرسالة؛ تبقى كلمة مرورك كما هي.',
        ],
        cta: 'اختيار كلمة مرور جديدة',
    },
    invitation: {
        subject: 'دعوة إلى لوحة عائلة {household}',
        lines: ['أنت مدعو للانضمام إلى لوحة عائلة {household}.', 'الدعوة صالحة لمدة 7 أيام.'],
        cta: 'قبول الدعوة',
    },
    // Golf 8 (0050): uitnodiging voor de familiekring. Geen woorden over gezondheid; wel dat het
    // geen alarmdienst is.
    // Golf 8 ronde 1 (ON-3): een huisgenoot uitnodigen (rol parent).
    houseInvite: {
        subject: '{inviter} يدعوك إلى {household}',
        lines: [
            'يدعوك {inviter} إلى {household} على AMUMIN: جدول المهام، ومن سيأكل، والحجوزات، وتقاسم التكاليف، على هاتفك.',
            'يحصل شركاء السكن على الصلاحيات نفسها التي لدى {inviter}.',
            'الدعوة صالحة لمدة 7 أيام.',
        ],
        cta: 'عرض الدعوة',
    },
    circleInvite: {
        subject: '{inviter} يدعوك للمتابعة',
        lines: [
            'يدعوك {inviter} لمتابعة لوحة عائلة {household} باسم "{label}".',
            'يقول {name} بنفسه على اللوحة إن كان ذلك مناسبًا. بعدها ترى فقط ما يوافق عليه {name}.',
            'هذه ليست خدمة طوارئ.',
            'الدعوة صالحة لمدة 7 أيام.',
        ],
        cta: 'عرض الدعوة',
    },
    existingAccount: {
        subject: 'لديك حساب {product} بالفعل',
        lines: [
            'حاول أحدهم إنشاء حساب جديد بهذا البريد الإلكتروني، لكن يوجد حساب بالفعل.',
            'هل كان هذا أنت؟ سجّل الدخول ببساطة. نسيت كلمة المرور؟ اطلب كلمة مرور جديدة عبر الزر أدناه.',
            'لم يكن هذا أنت؟ لا حاجة لفعل أي شيء؛ لم يتغير شيء.',
        ],
        cta: 'تسجيل الدخول',
    },
    newLogin: {
        subject: 'تسجيل دخول جديد إلى حساب {product}',
        lines: [
            'في {when} تم تسجيل الدخول من متصفح لم نكن نعرفه.',
            'هل كان هذا أنت؟ لا حاجة لفعل أي شيء.',
            'لم يكن هذا أنت؟ غيّر كلمة مرورك وسجّل الخروج من كل مكان عبر {origin}/instellingen/beveiliging.',
        ],
    },
    devicePaired: {
        subject: 'رُبط الجهاز اللوحي «{device}» بـ {room}',
        lines: [
            'في {when} رُبط الجهاز اللوحي «{device}» بغرفة {room} في لوحة عائلتكم.',
            'هل قمت بذلك أنت أو شريكك؟ لا حاجة لفعل أي شيء.',
            'لا تعرف هذا؟ ألغِ الربط عبر {origin}/apparaten وغيّر كلمة مرورك.',
        ],
    },
    loginCode: {
        subject: '{code} هو رمزك لـ {product}',
        code: 'رمزك: {code}',
        whyNetwork: 'تريد إضافة شبكة موثوقة. أدخل هذا الرمز لتأكيد ذلك.',
        whyLogin: 'تم تسجيل الدخول بكلمة مرورك. أدخل هذا الرمز في المتصفح نفسه؛ بعد التأكيد نثق بهذا المتصفح 30 يومًا (حتى {until}).',
        details: 'المتصفح: {browser} · الشبكة: {network} · {when}.',
        unknown: 'غير معروف',
        validity: 'الرمز صالح لمدة 10 دقائق.',
        warning: 'لا نطلب هذا الرمز أبدًا عبر الهاتف أو الدردشة أو البريد الإلكتروني؛ أدخله فقط على {host}.',
        cta: 'لم يكن هذا أنا',
    },
    trustedBrowser: {
        subject: 'متصفح موثوق جديد لـ {product}',
        someBrowser: 'متصفح',
        lines: [
            '{browser} الآن متصفح موثوق، صالح حتى {until}.',
            'في هذا المتصفح لن نطلب رمز البريد الإلكتروني حتى ذلك الحين؛ كلمة المرور مطلوبة دائمًا.',
            'لم يكن هذا أنت؟ غيّر كلمة مرورك وانسَ كل المتصفحات عبر {origin}/instellingen/beveiliging.',
        ],
    },
    trustedNetwork: {
        subject: '{label}: {verb} بواسطة {name}',
        verbs: {
            added: 'أُضيفت كشبكة موثوقة (لم تُؤكَّد بعد)',
            confirmed: 'أُكّدت كشبكة موثوقة',
            updated: 'عُدّلت',
            disabled: 'أُوقفت كشبكة موثوقة',
            removed: 'حُذفت من الشبكات الموثوقة',
        },
        household: 'هذا يسري على كل الوالدين في البيت: من هذه الشبكة لا نطلب رمز البريد الإلكتروني بعد كلمة المرور.',
        identity: 'هذا يسري على {name} فقط.',
        check: 'هذا غير صحيح؟ راجع الشبكات الموثوقة عبر {origin}/instellingen/beveiliging.',
    },
    lockout: {
        subject: 'تسجيل الدخول برمز البريد الإلكتروني محظور مؤقتًا',
        lines: [
            'طُلبت رموز دخول كثيرة جدًا أو أُدخلت خطأً. لن نرسل رموزًا جديدة حتى {until}.',
            'لم يكن هذا أنت؟ ربما يعرف شخص آخر كلمة مرورك: غيّرها عبر «نسيت كلمة المرور».',
        ],
    },
    wanChanged: {
        subject: 'تغيّر عنوان الإنترنت لخادمك',
        lines: [
            'في {when} حصل الخادم على عنوان إنترنت جديد من مزوّد الخدمة.',
            'الشبكة الموثوقة «البيت (WAN)» تتبع ذلك تلقائيًا. لم تتوقع هذا؟ تحقّق من جهاز التوجيه (الراوتر) ومن الشبكات الموثوقة.',
        ],
    },
    recoveryReuse: {
        subject: 'انتبه: الجهاز اللوحي «{device}» عُلّم كمشبوه',
        lines: [
            'استُخدم رمز الاسترداد للجهاز اللوحي «{device}» مرة ثانية.',
            'عُلّم الجهاز مؤقتًا كمشبوه. تحقّق في التطبيق تحت الأجهزة من أن كل شيء صحيح، ثم أكّد الربط أو ألغِه.',
        ],
    },
    familyLink: {
        subject: '{name} يريد الربط مع لوحة عائلتكم',
        lines: [
            '{name} يريد مشاركة بعض الأشياء معكم، مثل أعياد الميلاد وقوائم الأمنيات.',
            'بعدها تختارون أنتم ما تشاركونه بالمقابل. الدعوة صالحة لمدة 7 أيام.',
            'ليس لديكم {product} بعد؟ أنشئوا أولًا حسابًا مجانيًا بهذا البريد الإلكتروني.',
        ],
        cta: 'عرض الربط',
    },
    billing: {
        signupCode: {
            subject: '{code} هو رمزك لإكمال التسجيل',
            lines: [
                'مرحبًا بك في {product}! رمزك هو {code}.',
                'اكتب الرمز في الشاشة التي تسجّل فيها، أو استخدم الزر أدناه في المتصفح نفسه.',
                'الرمز صالح لمدة 10 دقائق والزر لمدة 24 ساعة. لم تسجّل؟ تجاهل هذه الرسالة؛ لن يحدث شيء.',
                'لا نطلب هذا الرمز أبدًا عبر الهاتف أو الدردشة أو البريد الإلكتروني؛ أدخله فقط على {host}.',
            ],
            cta: 'إكمال التسجيل',
        },
        priceLine: 'بعد ذلك تبلغ التكلفة {price}. يمكنك الإلغاء في أي وقت.',
        priceUnknown: 'سنخبرك بالتكلفة بعد ذلك قبل النهاية بوقت كافٍ. يمكنك الإلغاء في أي وقت.',
        perMonth: '{amount} شهريًا',
        trialWelcome: {
            subject: 'مرحبًا! شهرك التجريبي مستمر حتى {date}',
            lines: [
                'يسعدنا أنكم تستخدمون {product}. الشهر الأول مجاني حتى {date} ضمنًا.',
                'لا تحتاج الآن إلى دفع أي شيء أو إدخال أي بيانات. سنرسل لك تذكيرًا قبل النهاية بأسبوع.',
            ],
            cta: 'افتح التطبيق',
        },
        trialReminder7d: {
            subject: 'أسبوع مجاني آخر: شهرك التجريبي مستمر حتى {date}',
            lines: [
                'شهرك التجريبي في {product} مستمر حتى {date}.',
                'هل تريد المتابعة بعد ذلك؟ أضف بيانات الدفع في الإعدادات › الاشتراك.',
                'إن لم تفعل شيئًا، يمكنك بعد ذلك مشاهدة كل شيء، لكن دون إضافة أو تغيير. لا نحذف شيئًا.',
            ],
            cta: 'عرض الاشتراك',
        },
        trialReminder1d: {
            subject: 'اليوم هو آخر يوم مجاني لك',
            lines: [
                'اليوم ({date}) هو آخر يوم من شهرك المجاني في {product}.',
                'هل تريد المتابعة دون انقطاع؟ أضف بيانات الدفع اليوم في الإعدادات › الاشتراك.',
                'إن لم تفعل شيئًا، تصبح اللوحة غدًا للعرض فقط. تبقى بياناتك محفوظة.',
            ],
            cta: 'إضافة بيانات الدفع',
        },
        trialExpired: {
            subject: 'انتهى شهرك التجريبي',
            lines: [
                'انتهى شهرك المجاني في {product}. كل شيء ما زال موجودًا: يمكنك مشاهدة التقويم وغيره، وعلى اللوحة أيضًا.',
                'تعود الإضافة والتغيير ممكنة بمجرد إضافة بيانات الدفع.',
                'هل تريد التوقف؟ لا تحتاج إلى فعل شيء. لا نحذف بياناتك تلقائيًا أبدًا؛ يمكنك حذفها في الإعدادات › بياناتك.',
            ],
            cta: 'عرض الاشتراك',
        },
        expiredFollowup: {
            subject: 'هل تريدون المتابعة مع {product}؟',
            lines: [
                'انتهى شهركم التجريبي قبل شهر. ما زالت اللوحة للعرض فقط.',
                'يمكنكم المتابعة في أي وقت: أضيفوا بيانات الدفع في الإعدادات › الاشتراك.',
                'تفضّلون التوقف؟ ألغوا الاشتراك أو احذفوا لوحة العائلة في الإعدادات › بياناتك. لن نرسل رسائل أخرى بهذا الشأن.',
            ],
            cta: 'عرض الاشتراك',
        },
        cancelled: {
            subject: 'تم إلغاء اشتراكك',
            lines: [
                'لقد ألغيت اشتراكك في {product}. حتى {date} يعمل كل شيء كما هو الآن.',
                'بعد ذلك يمكنك مشاهدة كل شيء، لكن دون تغيير. لا نحذف شيئًا تلقائيًا.',
                'غيّرت رأيك؟ يمكنك المتابعة حتى {date} في الإعدادات › الاشتراك.',
            ],
            cta: 'عرض الاشتراك',
        },
    },
};
//# sourceMappingURL=email.ar.js.map